import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Modal } from "bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";
import { EncryptionService } from "src/app/services/encryption.service";
import { AppService } from "src/app/services/services";

@Component({
    selector: 'nri-app-complete',
    templateUrl: './complete.component.html',
    styleUrls: ['./complete.component.scss']
})

export class CompleteComponent implements OnInit{
    complete:boolean = false;
    verification: string = "Your Application Successfully Submitted For Verification";
    applicationNumber: string = "";
    remarks:string = "";
    statusModal: any;
    completeModal: any;
    erefNo:string = "";
    panNumber: string = '';
    @ViewChild('errorComp') errorComp : ErrorModalComponent;
    pisPdf:boolean = false;
    load:boolean = false;
    NRO:string = '';
    constructor(private router:Router,private toastr: ToastrService,private loader: NgxUiLoaderService, public _http: AppService, public encrypt:EncryptionService){}
    ngOnInit() {
      this._http.checkComplete(true);
      if(history.state.RefNo) {
        this.applicationNumber = history.state.RefNo;
      }
      this._http.scroll();
      this._http.getRefNum().subscribe(data=>{
        this.erefNo = data;
      });
      if(sessionStorage.getItem('NRO')) {
      this.NRO= sessionStorage.getItem('NRO') || '';
      }
      if(!this.erefNo && sessionStorage.getItem('AxNo')){
        this.erefNo = sessionStorage.getItem('AxNo') || "";
      }
      // if(this.erefNo){
      //   this.getDIYStatus(this.erefNo);
      // }
      this._http.getStatus().subscribe(data=>{
        this.panNumber = data.Pan;
      })
      // setTimeout(() => {
      //   this.GeneratePDF();
      // }, 200);
    }

    // getDIYStatus(ref: any){
    //   let url = 'DIY/DIYOverallStatus';
    //   const checkSum = ref;
    //   let params = {
    //     'ReferenceNumber': ref
    //   }
    //   this.loader.start();
    //   this._http.httpPost(url,params, checkSum).subscribe({
    //     next: (data:any)=>{
    //       this.loader.stop();
    //       let value = this.encrypt.decryptUsingAES256(data.OutPut)
    //       if(value && value.IsSuccess){
    //         let item = value.overallLists;
    //         let refNo = value.ReferenceNumber;
    //         this.pisPdf = value.PIS;
    //         if(value.PanNumber){
    //           this.panNumber = value.PanNumber;
    //         }
    //          if (item[1].DIY !== 'Y' || item[1].DBO === 'R') {
    //           if(item[1].DBO !== 'R'){
    //             this.router.navigate(['/pan'], { replaceUrl: true });
    //           }
    //           if(item[1].DBO === 'R'){
    //             this.errorComp.ModalShow(item[1].Remarks, true , '/pan');
    //           }
    //         }
    //         else if(item[2].DIY !== 'Y' || item[2].DBO === 'R'){
    //           if(item[2].DBO !== 'R'){
    //             this.router.navigate(['/passport'], { replaceUrl: true });
    //           }
    //           if(item[2].DBO === 'R'){
    //             this.errorComp.ModalShow(item[2].Remarks, true , '/passport');
    //           }
    //         }
    //         else if(item[4].DIY !== 'Y' || item[4].DBO === 'R'){
    //           if(item[4].DBO !== 'R'){
    //             this.router.navigate(['/foreign-address'], { replaceUrl: true });
    //           }
    //           if(item[4].DBO === 'R'){
    //             this.errorComp.ModalShow(item[4].Remarks, true , '/foreign-address');
    //           }
    //         }
    //         else if(item[5].DIY !== 'Y' || item[5].DBO === 'R'){
    //           if(item[5].DBO !== 'R'){
    //             this.router.navigate(['/address'], { replaceUrl: true });
    //           }
    //           if(item[5].DBO === 'R'){
    //             this.remarks = item[5].Remarks;
    //             this.errorComp.ModalShow(item[5].Remarks, true , '/address');
    //             // this.errorComp.ModalShow(item[5].Remarks)
    //           }
    //         }
    //         else if(item[6].DIY !== 'Y' || item[6].DBO === 'R'){
    //           if(item[6].DBO === 'R'){
    //             this.errorComp.ModalShow(item[6].Remarks, true , '/visa');
    //           }
    //           if(item[6].DBO !== 'R'){
    //             this.router.navigate(['/visa'], { replaceUrl: true });
    //           }
    //         } 
    //         else if(item[7].DIY !== 'Y' || item[7].DBO === 'R'){
    //           if(item[7].DBO === 'R'){
    //             this.errorComp.ModalShow(item[7].Remarks, true , '/fatca');
    //           }
    //           if(item[7].DBO !== 'R'){
    //             this.router.navigate(['/fatca'], { replaceUrl: true });
    //           }
    //         }
    //         else if(item[9].DIY !== 'Y' || item[9].DBO === 'R'){
    //           if(item[9].DBO === 'R'){
    //             this.errorComp.ModalShow(item[9].Remarks, true , '/bank');
    //           }
    //           if(item[9].DBO !== 'R'){
    //             this.router.navigate(['/bank'], { replaceUrl: true });
    //           };
    //         }
    //         else if(item[10].DIY !== 'Y' || item[10].DBO === 'R'){
    //           if(item[10].DBO === 'R'){
    //             this.errorComp.ModalShow(item[10].Remarks, true , '/segments');
    //           }
    //           if(item[10].DBO !== 'R'){
    //             this.router.navigate(['/segments'], { replaceUrl: true });
    //           }
    //         }
    //         else if(item[11].DIY !== 'Y' || item[11].DBO === 'R'){
    //           if(item[11].DBO === 'R'){
    //             this.errorComp.ModalShow(item[11].Remarks, true , '/fatca');
    //           }
    //           if(item[11].DBO !== 'R'){
    //             this.router.navigate(['/fatca'], { replaceUrl: true });
    //           }
    //         }
    //         else{
    //           this.finalStage();
    //         }
    //       }
    //     },
    //     error: _error=>{
    //       this.loader.stop();
    //     }
    //   });
    // }

    finalStage(){
        this.loader.start();
        const path = 'DIY/DiyUpdtStatus';

        const params = {
            ReferenceNumber: this.erefNo,
            Status: 'Completed'
        }
        let checksum = this.erefNo + 'Completed';
        this._http.httpPost(path, params, checksum).subscribe({
            next:(data:any) => {
              let val = this.encrypt.decryptUsingAES256(data.OutPut)
                if(val.IsSuccess){
                    this.loader.stop();
                    // this.toastr.success(val.Success);
                    sessionStorage.setItem("stageFinished", val.IsSuccess);
                    const refNo = val.ReferenceNumber;
                    if(refNo){
                      this.applicationNumber = refNo;
                    }
                    setTimeout(() => {
                      this.GeneratePDF();
                    }, 200);
                }
            },error: e => {
                this.loader.stop();
                this.errorComp.ModalShow(e.error.Message);
            }
        });
    }

    stageValidate(){
      sessionStorage.clear();
      location.reload();
    }
    // RegisterPage() {
      
    // }
    downloadAOF(aof:boolean){
      this.loader.start();
      const path = "DIY/DiyAofDownload";
      const params = {
          "ReferenceNumber": this.erefNo,
          "Guid" : 0,
          "pannumber": this.panNumber,
          "pdf": aof ? "AOF" : "PIS"
      }
      const checkSum = this.erefNo;
      this._http.httpPost(path, params, checkSum).subscribe({
          next:(data:any)=>{
            this.loader.stop();
            let val=this.encrypt.decryptUsingAES256(data.OutPut)
              if(val.IsSuccess){
                if (val.Pdf && aof) {
                  const byteArray = new Uint8Array(atob(val.Pdf).split("").map(char => char.charCodeAt(0)));
                  // const pdfContent = atob(data.Pdf);
                  const blob = new Blob([byteArray], { type: 'application/pdf' });
                  const filename = this.applicationNumber ? `${this.applicationNumber}.pdf` : `Aof.pdf`;
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = filename;
                  setTimeout(() => {
                      a.click();
                      URL.revokeObjectURL(url);
                  }, 0);
                  // this.toastr.success("PDF Downloaded Successfully");
                  this.statusModal.hide();
                } 
                else if (val.PISPdf && !aof) {
                  const byteArray = new Uint8Array(atob(val.PISPdf).split("").map(char => char.charCodeAt(0)));
                  // const pdfContent = atob(data.Pdf);
                  const blob = new Blob([byteArray], { type: 'application/pdf' });
                  const filename = this.applicationNumber ? `${this.applicationNumber}_NREPIS.pdf` : `NREPIS.pdf`;
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = filename;
                  setTimeout(() => {
                      a.click();
                      URL.revokeObjectURL(url);
                  }, 0);
                  // this.toastr.success("PDF Downloaded Successfully");
                  this.statusModal.hide();
                } 
                else {
                  this.errorComp.ModalShow("PDF content not found in the response.");
                  // this.toastr.error("PDF content not found in the response.");
                }
              }else{
                this.statusModal.hide();
                this.errorComp.ModalShow(val.Error || "PDF content not found");
                // this.toastr.error(val.Error);
              }
          },error: e=>{
              this.loader.stop();
              this.errorComp.ModalShow(e.error.Message);
              // this.toastr.error(e.error.Message);

          }
      });
    }
    GeneratePDF(){
      this.loader.start();
      const path = "DIY/GeneratePDF";
      const params = {
          "ReferenceNumber": this.erefNo,
          "Type":"dummy",
          "PanNumber":this.panNumber,
          "guid":2
      }
      const checkSum = this.erefNo + this.panNumber;
      this._http.httpPost(path, params, checkSum).subscribe({
          next:(data:any)=>{
            if(data){
              let val = this.encrypt.decryptUsingAES256(data.OutPut);
              this.loader.stop();
              this.load = true;
              // this.sendAOF();
              this.aofSend();
              const element = document.getElementById('appstatus') as HTMLElement;
              this.statusModal = new Modal(element, {backdrop: 'static', keyboard: false});
              this.statusModal.show();
            }
            
          },error: e => {
              this.loader.stop();
              // this.toastr.error(e.error.Message);
              this.errorComp.ModalShow(e.error.Message);
          }
      });
    }

    sendAOF(){
      this.loader.start();
      const path = "DIY/DiyAofSend";
      const params = {
          "ReferenceNumber": this.erefNo,
          "Type":"dummy",
          "PanNumber":this.panNumber,
          "guid":2
      }
      const checkSum = this.erefNo + this.panNumber;
      this._http.httpPost(path, params, checkSum).subscribe({
          next:(data:any)=>{
            if(data){
              let val = this.encrypt.decryptUsingAES256(data.OutPut);
              this.loader.stop();
            }
            
          },error: e => {
              this.loader.stop();
              this.errorComp.ModalShow(e.error.Message);
          }
      });

    }

    aofSend(){
      this.loader.start();
      const URL = `DIY/EmailPDFURL?ReferenceNumber=${this.erefNo}&PanNumber=${this.panNumber}`;
      this._http.httpGet(URL).subscribe({
        next: data => {
          this.loader.stop();
          if(data){
            
          }
        }, error: err => {
          this.loader.stop();
        }
      })
    }
}